import { useRouter } from 'next/router';

import { useMobileAppBannerSessionStore } from '~/components/Banners/MobileAppBanner/hooks/useMobileAppBannerSessionStore';
import { Pathname } from '~/constants/pathname';
import { useIsIosMobileDevice } from '~/hooks/useIsIosMobileDevice';

const SUPPORTED_LANDING_PATHNAMES: string[] = [
  Pathname.BoardByBoardId,
  Pathname.LibraryByLibraryId,
  Pathname.LibraryGeneral,
];

type UseShouldShowMobileAppBannerResult = {
  shouldShow: boolean;
};

const isPrivateClipPathname = (pathname: string): boolean => {
  const isPublicSharePathname = pathname === '/a/[[...slug]]' || pathname.startsWith('/a/');

  return pathname.endsWith('/c/[clipId]') && !isPublicSharePathname;
};

// Deliberately overlaps SidebarNavigationItemOpenMobileApp, gated on the same iOS-mobile check:
// that entry point is tucked inside the nav drawer, while this banner surfaces the same prompt
// inline on content pages without requiring the user to open the drawer first.
export const useShouldShowMobileAppBanner = (): UseShouldShowMobileAppBannerResult => {
  const { pathname } = useRouter();
  const { isIosMobileDevice } = useIsIosMobileDevice();
  const isDismissed = useMobileAppBannerSessionStore((state) => state.isDismissed);

  const isSupportedLandingPage = SUPPORTED_LANDING_PATHNAMES.includes(pathname);
  const isSupportedPage = isSupportedLandingPage || isPrivateClipPathname(pathname);
  const shouldShow = isIosMobileDevice && isSupportedPage && !isDismissed;

  return { shouldShow };
};
